import {
  ASC,
  DataTable,
  DateFormatter,
  getSortDir,
  includes,
  PriceFormatter,
  SortFilters,
  sortWithFunction,
  StatsGameFormatter,
  toLower,
  urlReplace,
} from "best-common-react";
import React, { useEffect, useState } from "react";
import RouteConstants from "../../../constants/RouteConstants";
import { UserTicketRequestDTO } from "../../../types/UserRequest";
import { Link } from "react-router-dom";

const RequestFormatter = ({ value }) => {
  const url = urlReplace(RouteConstants.ADMIN.REQUESTS_EDIT, { requestId: value });
  return <Link to={url}>{value}</Link>;
};

const Columns = [
  {
    name: "Request",
    key: "requestId",
    width: 100,
    sortable: true,
    readonlyFormatter: RequestFormatter,
  },
  {
    name: "Game",
    key: "game",
    minWidth: 350,
    readonlyFormatter: StatsGameFormatter,
    sortable: true,
  },
  {
    name: "# of Tickets",
    key: "quantity",
    width: 125,
    sortable: true,
    cellClass: "justify-content-center",
  },
  {
    name: "Tickets Sent",
    key: "ticketsSentDisplay",
    minWidth: 200,
    sortable: false,
  },
  {
    name: "Total Ticket Cost",
    key: "totalTicketCost",
    width: 150,
    sortable: true,
    readonlyFormatter: PriceFormatter,
    cellClass: "justify-content-center",
  },
  {
    name: "Charge Date",
    key: "chargeDate",
    minWidth: 150,
    sortable: true,
    readonlyFormatter: DateFormatter,
  },
  {
    name: "Requester",
    key: "requester",
    minWidth: 300,
    sortable: true,
  },
  {
    name: "Department",
    key: "department",
    minWidth: 200,
    sortable: true,
  },
  {
    name: "Business",
    key: "business",
    minWidth: 200,
    sortable: true,
  },
];

const freeTextFilter = (data: UserTicketRequestDTO[], search?: string) =>
  search?.length
    ? data.filter(
        (data: UserTicketRequestDTO) =>
          includes(data.business, search) ||
          includes(data.requestId.toString(), search) ||
          includes(data.gamePk.toString(), search) ||
          includes(data.department, search) ||
          includes(data.quantity.toString(), search) ||
          includes(data.totalTicketCost.toString(), search) ||
          includes(data.requester, search) ||
          includes(data.orderCost.toString(), search)
      )
    : data;

type SeasonTicketsReportDataTableProps = {
  data: UserTicketRequestDTO[];
  reportData: any;
};

const SeasonTicketsReportDataTable = ({ data, reportData }: SeasonTicketsReportDataTableProps) => {
  const [displayData, setDisplayData] = useState<UserTicketRequestDTO[]>([]);
  const [sortFilters, setSortFilters] = useState<SortFilters<UserTicketRequestDTO>>({ key: "game", direction: ASC });

  useEffect(() => {
    if (data) {
      setDisplayData(
        sortWithFunction(
          freeTextFilter(data, reportData.search),
          sortFilters.key,
          getSortDir(sortFilters.direction),
          (value) => {
            if (sortFilters.key === "game") {
              return value.gameDate;
            } else {
              return value ? toLower(value) : "";
            }
          }
        )
      );
    } else {
      setDisplayData([]);
    }
  }, [data, sortFilters, reportData.search]);

  return (
    <div className="bcr-mt-2">
      <DataTable
        columns={Columns}
        data={displayData}
        sortColumn={sortFilters.key}
        sortDirection={sortFilters.direction}
        sortFunction={(key, direction) => setSortFilters({ key, direction })}
        statusTextOverride={(_selected, total) => {
          return `${total} Requests`;
        }}
        tableHeights={{
          autogrow: true,
        }}
      />
    </div>
  );
};

export default SeasonTicketsReportDataTable;
